<template>
    <div class="rule-generator">
        <div class="expand-layer">
            <span
                class="trigger"
                :class="{ expand: expand }"
                @click="expand = !expand"
            >{{ expand ? '折叠' : '展开' }}<v-icon name="arrow_dropdown" /></span>
        </div>
        <div
            v-show="!expand"
            class="brief-wrapper"
        >
            <template v-if="briefHtml.length === 0">
                请配置规则
            </template>
            <template v-else-if="briefHtml.length === 1">
                <template v-for="(grp, gi) in briefHtml">
                    <span
                        :key="gi"
                    ><span
                        v-for="(item, index) in grp.children"
                        :key="index"
                    >
                        <span
                            v-if="index > 0"
                            class="rule-relation"
                        >{{ grp.logicWord }}</span>{{ item }}</span>
                    </span>
                </template>
            </template>
            <template v-else>
                <template v-for="(grp, gi) in briefHtml">
                    <span
                        :key="gi"
                    ><span
                        v-if="gi > 0"
                        class="grp-relation"
                    >{{ ruleList.logic === 'and' ? '并且' : '或者' }}</span>(<span
                        v-for="(item, index) in grp.children"
                        :key="index"
                    >
                        <span
                            v-if="index > 0"
                            class="rule-relation"
                        >{{ grp.logicWord }}</span>{{ item }}</span>)
                    </span>
                </template>
            </template>
        </div>
        <div v-show="expand">
            <template v-if="group.length > 0">
                <logic-selector
                    v-if="group.length > 1"
                    :value="ruleLogic"
                    @change="onChangeLogic"
                />
                <template v-for="(item, index) in group">
                    <rule-group
                        ref="grp"
                        :key="index"
                        :value="item"
                        :rule-options="ruleOptions"
                        :preloaded-data="preloadedCgiData"
                        @remove="
                            () => {
                                onRemoveGroup(index);
                            }
                        "
                        @change="
                            value => {
                                onChangeGroup(value, index);
                            }
                        "
                    />
                </template>
                <div
                    class="rule-generator__add-group"
                    @click="onAddGroup"
                >
                    <v-icon name="add" /><span>新建条件组</span>
                </div>
            </template>
            <div
                v-else
                class="empty"
            >
                <div :class="{ 'add-wrapper': true, 'group-invalid': !valid }">
                    <v-icon name="add" /><span>添加条件</span>
                    <rule-selector
                        :rule-options="ruleOptions"
                        :value="currRuleSelectedVal"
                        @change-component="initGroup"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import RuleGroup from './components/rule-group';
import LogicSelector from './components/logic-selector';
import preloadedData from './utils/preloaded-data.js';
import RuleSelector from './components/rule-selector';
import { getRuleData } from './utils/ruleConvert';

const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
  name: 'RuleGenerator',

  components: {
    RuleGroup,
    LogicSelector,
    RuleSelector,
  },

  props: {
    // 传入值
    default: {
      type: Object,
      default() {
        return null;
      },
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    // 下拉树定义，如果是字符串则展示一个没有下拉只有名字的面板
    ruleOptions: {
      type: [Array, String],
      default() {
        return null;
      },
    },

    // 为空时默认选中的规则选项
    ruleSelectedVal: {
      type: String,
      default() {
        return '';
      },
    },
  },

  data() {
    return {
      expand: true,
      ruleList: null,
      logicList: null,
      // 需要预处理的组件中的cgi
      preloadedCgiData: {},
      valid: true,
      currRuleSelectedVal: '',
    };
  },

  computed: {
    briefHtml() {
      const grpBriefs = [];
      // eslint-disable-next-line no-unused-expressions
      this.ruleList.children
                && this.ruleList.children.forEach((grp) => {
                  const logicWord = grp.logic === 'and' ? '并且' : '或者';
                  const grpBrief = [];
                  if (grp.ruleList.length > 0) {
                    grp.ruleList.forEach((item) => {
                      if (item.showData.validation) {
                        if (item.showData.brief) {
                          grpBrief.push(item.showData.brief);
                        }
                      } else {
                        grpBrief.push(`${item.showData.info.text}未填写`);
                      }
                    });
                    grpBriefs.push({ children: grpBrief, logicWord });
                  }
                  // grpBriefs.push(grpBrief.join(` <span class="rule-relation">${logicWord}</span> `));
                });
      return grpBriefs;
    },
    group() {
      return (this.ruleList && this.ruleList.children) || [];
    },
    ruleLogic() {
      return (this.ruleList || {}).logic;
    },
  },
  watch: {
    default() {
      this.resetRule();
    },

    ruleSelectedVal(val) {
      this.currRuleSelectedVal = val;
    },
  },
  created() {
    this.resetRule();
    // 对组件中需要拉取的数据进行预处理
    preloadedData(this, { ruleOptions: this.ruleOptions }).then((listQueue) => {
      listQueue.forEach((item) => {
        if (item.status === 'success') {
          this.preloadedCgiData[item.name] = item.response;
        }
      });
    });
  },

  methods: {
    resetRule() {
      const ruleList = (this.default && this.default.showData) || { children: [] };
      this.ruleList = ruleList;
      this.onChange();
    },
    onRemoveGroup(index) {
      this.ruleList.children.splice(index, 1);
      this.onChange();
    },

    onAddGroup() {
      const childrenRef = this.ruleList.children;
      const newGroup = {
        logic: 'and',
        ruleList: [],
      };
      childrenRef.splice(childrenRef.length, 1, newGroup);
      this.onChange();
    },
    initGroup(v) {
      // this.onAddGroup();
      let value;
      // 特殊处理value值
      if (v.componentName === 'CustomerStatus') {
        value = {
          statusValue: undefined,
          holderValue: undefined,
        };
      }
      if (v.componentName === 'Education') {
        value = {
          logicValue: '==',
          educationValue: [],
        };
      }
      const newGroup = {
        logic: 'and',
        ruleList: [
          {
            showData: {
              componentName: v.componentName,
              info: v,
              value: value || null,
              brief: '',
              validation: false,
            },
            ruleData: null,
          },
        ],
      };
      this.onChangeGroup(newGroup, 0);
    },
    onChange() {
      this.valid = true;
      console.log('ruleList:', this.ruleList);
      const ruleData = getRuleData(this.ruleList);
      // 将数据转换为Themis的引擎数据
      // const themis = ruleConvertToThemis({
      //     ruleList: this.ruleList,
      //     logicList: this.logicList
      // });
      // // 这里是转换与反编译的测试
      // // 将配置转变为以配置的字段为key，组件信息为值的map
      // const ruleOptionsMap = generatorRuleOptionsMap(this.ruleOptions);
      // // 将Themis数据转换为前端规则引擎的数据
      // const base = ruleConvertToBase(themis, ruleOptionsMap);
      // console.log('-------- ruleOptionsMap');
      // console.log(ruleOptionsMap);
      // console.log('-------- themis');
      // console.log(themis);
      // console.log('-------- base');
      // console.log(base);
      // console.log('-------- orign');
      // console.log({
      //     ruleList: this.ruleList,
      //     logicList: this.logicList
      // });
      this.$emit('change', {
        ruleData,
        showData: this.ruleList,
        validation: this.validateData(),
      });
    },

    onChangeGroup(value, index) {
      this.$set(this.ruleList.children, index, value);
      this.onChange();
    },

    onChangeLogic(value) {
      this.$set(this.ruleList, 'logic', value);
      this.onChange();
    },
    validate() {
      if (!this.group || this.group.length === 0) {
        this.valid = false;
        return Promise.resolve(false);
      }
      const defers = this.group.map((grp, i) => this.$refs.grp[i].validate());
      return Promise.all(defers).then(([...validations]) => {
        let valid = true;
        validations.forEach((itemValid) => {
          if (!itemValid) {
            valid = false;
          }
        });
        return valid;
      });
    },
    validateData() {
      let validation = !!(this.ruleList.children.length && this.ruleList.children.length > 0);
      if (validation) {
        this.ruleList.children.forEach((item) => {
          if (!item.validation) {
            validation = false;
          }
        });
      }
      return validation;
    },
  },
};
</script>

<style lang="less">
@import './style/style.less';
</style>
